export interface IJsonExport {
  ctxId: string;
}

export class JsonExportFormValues {
  ctxId: string = '';
  constructor(init?: IJsonExport) {
    Object.assign(this, init);
  }
}